import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHttp, useNotification } from 'src/hooks';

const TwitterCallback: React.FC = () => {
  const navigate = useNavigate();
  const { sendRequest, error } = useHttp();
  const notify = useNotification();
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');

  const fetchTwitterUser = () => {

    sendRequest(
      {
        url: `twitter/callback?code=${code}&state=${state}`,
        method: 'GET',
      },
      (data: any) => {
        navigate(`/profile`);
      },
    );
  };


  useEffect(() => {
    fetchTwitterUser();
  }, []);


  useEffect(() => {
    if (error) {
      notify(`${error}`, 'error');
      navigate('/');
    }
  }, [error]);
  return (
    <div>
      <div className="text-white text-center">Redirecting you back to the platform in while...</div>
    </div>
  );
};

export default TwitterCallback;
